import React, { useState } from "react";
import "./Categories.css";


const Categories = () => {
  const [activeTab, setActiveTab] = useState("des-members");

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="category-container"> 
          <div className="the-categories">
        <section className="section-categories">
        <div className="sectiontop-line"></div>
        <h2 className="sectiontitle">CATEGORIES</h2>
        <div className="sectionbottom-line"></div>
        </section>
      </div>
    <div className="category-content">

      {/* Tabs Navigation */}
      <nav>
        <div className="nav nav-tabs category" id="nav-tab" role="tablist">
          <button
            className={`nav-item nav-link ${activeTab === "des-members" ? "active" : ""}`}
            onClick={() => handleTabChange("des-members")}
          >
            Designated Members
          </button>
          <button
            className={`nav-item nav-link ${activeTab === "non-des-members" ? "active" : ""}`}
            onClick={() => handleTabChange("non-des-members")}
          >
            Non-Designate Members
          </button>
          <button
            className={`nav-item nav-link ${activeTab === "institutional" ? "active" : ""}`}
            onClick={() => handleTabChange("institutional")}
          >
            Institutional
          </button>
        </div>
      </nav>

      {/* Tab Content */}
      <div className="tab-content" id="nav-tabContent">
        {/* Designated Members */}
        {activeTab === "des-members" && (
          <div className="tab-pane fade show active">
            <details>
              <summary className="active">Associate</summary>
              <ol>
                <li>
                  Is a person with associate designation by the ASG and any Actuarial Association which has a full membership of the International Actuarial
                  Association (IAA) and has at least two (2) years of post-qualification actuarial responsibility which
                  the Council may approve of;
                </li>
                <hr />
                <li>Has paid the prescribed entrance fees and dues for the year.</li>
              </ol>
            </details>
            <details>
              <summary>Fellow</summary>
              <ol>
                <li>
                  Is a person with Fellow designation by the ASG and any Actuarial Association which has a full membership of the International Actuarial
                  Association (IAA) and has at least two (2) years of post-qualification actuarial responsibility which
                  the Council may approve of;
                </li>
                <hr />
                <li>Has paid the prescribed entrance fees and dues for the year.</li>
              </ol>
            </details>
          </div>
        )}

        {/* Non-Designate Members */}
        {activeTab === "non-des-members" && (
          <div className="tab-pane fade show active">
            <details>
              <summary>Student</summary>
              <ol>
                <li>
                  Has a declared interest in actuarial matters or is performing actuarial or other related work in a
                  financial institution, an insurance company, academic institution, government office or an actuarial
                  consulting office;
                </li>
                <hr />
                <li>
                  Has completed an actuarial course or other related course in a University, or any other academic
                  institute recognized by the Society and has achieved a qualification thereof;
                </li>
                <li>Has paid the prescribed entrance fee and dues for the year.</li>
              </ol>
            </details>
            <details>
              <summary>Affiliate</summary>
              <details className="inner-details">
                <summary>Education Criteria</summary>
                <ol>
                  <li>Have a proven actuarial-related education over the course of their educational achievements.</li>
                  <li>
                    Have proven to be a regular attendee of ASG events over the last 3 years. <br />
                    <br /> AND either of the following below:
                  </li>
                </ol>
              </details>
              <details className="inner-details">
                <summary>Experience Criteria</summary>
                <ol>
                  <li>
                    Have at least 5 years working experience in an actuarial/ risk management position from any of the
                    practice areas including but not limited to:
                    <ol>
                      <li>Enterprise risk management</li>
                      <li>General Insurance</li>
                      <li>Health Insurance</li>
                      <li>Investment</li>
                      <li>Life Insurance</li>
                      <li>Pensions</li>
                      <li>
                        Actuarial consulting <br />
                        <br /> OR
                      </li>
                    </ol>
                  </li>
                  <li>
                    Have at least 5 years’ experience as an academic working in an actuarial/
                    statistics/ mathematics
                    department of a recognized university with proven actuarial-related research work(s) or
                    publication(s).
                  </li>
                </ol>
              </details>
            </details>
            <details>
              <summary>Honorary Member</summary>
              <ol>
                <li>
                  A person who on account of their position, appears to the Council to be able to contribute to
                  furthering the objectives of the Society, and who is not professionally engaged in practice as an
                  Actuary.
                </li>
                <hr />
              </ol>
            </details>
          </div>
        )}

        {/* Institutional */}
        {activeTab === "institutional" && (
          <div className="tab-pane fade show active">
            <p>
              A corporate body or Institution shall be admitted to affiliation with the Society as an Institutional
              Member for purposes of furthering the objectives of the Society, regulation or any reason that the Council
              shall approve of.
            </p>
          </div>
        )}
      </div>
    </div>
    </div>
  );
};

export default Categories;
